import apiClient from "../helpers/apiClient";

export const getNotifications = async () => {
    try {
        const response = await apiClient.get('/notifications/');
        return response.data;
    } catch (error) {
        console.error('Error fetching notifications:', error);
        throw error;
    }
};

export const getUnreadNotifies = async () => {
    try {
        const response = await apiClient.get('/notifications/unread_count/');
        return response.data;
    } catch (error) {
        console.error('Error fetching unread-notifications:', error);
        throw error;
    }
};

export const markAllNotifies = async () => {
    try {
        const response = await apiClient.post('/notifications/mark_all_as_read/');
        return response.data;
    } catch (error) {
        console.error('Error fetching unread-notifications:', error);
        throw error;
    }
};
